import { combineReducers } from "redux";
import flashcardsList from "./flashcardReducer";
import fastQuizQuestions from "./fastQuizReducer";
import scoreReport from "./scoreReportReducer";
import testUserDetails from "./testKnowledgeReducer";
import questionSetDetails from "./questionSetDetailsReducer";

export default combineReducers({
  flashcardsList,
  fastQuizQuestions,
  scoreReport,
  testUserDetails,
  questionSetDetails,
});
